import type { ComponentProps } from "react";
import { Store } from "lucide-react";
import { SectionCard } from "@/shared/components/ui/SectionCard";
import { BusinessFields } from "./BusinessFields";

export function BusinessSection(props: ComponentProps<typeof BusinessFields>) {
  return (
    <SectionCard title="Business details" icon={<Store />} description="How your business is set up.">
      <div className="space-y-[18px]">
        <BusinessFields {...props} />
      </div>
    </SectionCard>
  );
}
